module.exports = "<div class=\"geo-content__row geo-row--title\">\n    <div class=\"geo-columns--3c\">\n        <h1>{{usuariosModuleName.plural}}</h1>\n    </div>\n</div>\n\n<div class=\"geo-content__row\">\n    <button type=\"submit\" class=\"geo-button\" (click)=\"clickAdm()\">Administrador</button>\n    <button type=\"submit\" class=\"geo-button\" (click)=\"clickVisitor()\">Visitante</button>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/recursos-humanos/usuarios/usuario-change/usuario-change.component.html
 ** module id = 691
 ** module chunks = 0
 **/